(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inst-facade-lighting"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.facade-lighting').forEach(function (sec) {
  var btns = sec.querySelectorAll('[data-mode-set]');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sec.setAttribute('data-mode', btn.getAttribute('data-mode-set'));
      btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inst-laser-specsheet"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.laser-specsheet').forEach(function (sec) {
  var sheet = sec.querySelector('.laser-datasheet');
  var tabs = sec.querySelectorAll('[data-spec-tab]');
  tabs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sheet.setAttribute('data-active-spec', btn.getAttribute('data-spec-tab'));
      tabs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
